<template>
  <modal
    :title="setModel != undefined ? 'Update Branch' : 'Add Branch'"
    :size="'lg'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="countries == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="countries != null"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-4">
          <formGroup
            :title="'Name'"
            v-model="model.Name"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-8">
          <formGroup
            :title="'Title'"
            v-model="model.Title"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'Person'"
            v-model="model.Person"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'Phone'"
            v-model="model.Phone"
            :errors="errors"
            :rules="{ required: true, min: 10 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'Email'"
            v-model="model.Email"
            :errors="errors"
            :rules="{ email: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'TaxOffice'"
            v-model="model.TaxOffice"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'TaxNumber'"
            type="number"
            v-model.number="model.TaxNumber"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'Commission'"
            type="number"
            v-model.number="model.Commission"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'CountryId'"
            :as="'select'"
            :disabled="countries.length == 0"
            :buttons="true"
            v-model="model.CountryId"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option
                v-for="item in countries"
                :value="item.Id"
                :key="item.Code"
                >{{ item.Name }}</option
              >
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addCountriesOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'City'"
            v-model="model.City"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-4">
          <formGroup
            :title="'Town'"
            v-model="model.Town"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'Address'"
            :as="'textarea'"
            rows="5"
            v-model="model.Address"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Active'"
            :as="'checkbox'"
            v-model="model.Active"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="countries == null"
        :process="process"
        >{{ setModel != undefined ? "Update Branch" : "Add Branch" }}</Btn
      >
    </template>
  </modal>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Id: $event.Id, Name: $event.Name })"
  ></addCountries>
</template>

<script>
import addCountries from "@/views/countries/upsert";
export default {
  props: {
    setModel: Object,
  },
  components: { addCountries },
  data() {
    return {
      model: {
        Id: null,
        Name: "",
        CountryId: "",
        City: "",
        Town: "",
        Title: "",
        TaxOffice: "",
        TaxNumber: "",
        Address: "",
        Person: "",
        Email: "",
        Phone: "",
        Commission: "",
        Active: false,
      },
      process: false,
      countries: null,
      addCountriesOpen: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`Branchs`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The branch has been successfully updated."
                    : "The branch has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
